import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import 'material-icons/iconfont/outlined.css'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import FormTitle from '@components/text/formTitle'

import { getActiveTerms as getActiveTermsAction } from '@stores/actions/loan'

import {
  Container,
  TitleContainer,
  Section,
  Box,
  Text,
  TextBox,
  TitleText,
  Icon,
  CheckIcon,
  ArrowIcon,
  Line
} from './styles'

import { WindowContext } from '@components/windowContextProvider'
import { useNavigate } from 'react-router-dom'

const TermsModal = ({
  isOpen, setClose, beneficiary, activeTerms, getActiveTerms
}) => {

  const { id } = beneficiary
  const beneficiaryId = id

  const navigate = useNavigate()

  useEffect(
    () => {
      getActiveTerms({ beneficiaryId })
    },
    [beneficiaryId]
  )

  const { clientHeight } = React.useContext(WindowContext)

  const handleConsentTerm = (benId) => {
    navigate(`/unimed-assis/beneficiario/${benId}/termo-de-consentimento`)
  }

  const handleLoanTerm = (termId) => {
    navigate(`/unimed-assis/acompanhamento/emprestimos/termo-de-emprestimo/${termId}`)
  }

  const row = (term) => {
    return (
      <Box onClick={() => handleLoanTerm(term.loanId)}>
        <Icon>
          <CheckIcon className="material-icons-outlined">check_circle</CheckIcon>
        </Icon>
        <TextBox>
          <TitleText>
            Termo de Empréstimo
          </TitleText>
          <Text>
            {term.termDate}
          </Text>
        </TextBox>
        <ArrowIcon className="material-icons-outlined">chevron_right</ArrowIcon>
      </Box>
    )
  }

  return (
    <Container isOpen={isOpen} clientHeight={clientHeight}>
      <Section>
        <TitleContainer>
          <FormTitle
            title={beneficiary.name}
            onClickGoBack={setClose}
            topTitle="Termos do beneficiário"
          />
        </TitleContainer>
      </Section>
      <Line />
      <Section>
        {beneficiary.acceptedTerms && (
        <Box onClick={() => { handleConsentTerm(beneficiary.id) }}>
          <Icon>
            <CheckIcon className="material-icons-outlined">check_circle</CheckIcon>
          </Icon>
          <TextBox>
            <TitleText>
              Termo de consentimento
            </TitleText>
            <Text>
              {beneficiary.acceptedTerms}
            </Text>
          </TextBox>
          <ArrowIcon className="material-icons-outlined">chevron_right</ArrowIcon>
        </Box>
        )}
        {activeTerms?.map((term) => row(term))}
      </Section>
    </Container>
  )
}

TermsModal.propTypes = {
  isOpen: PropTypes.bool,
  setClose: PropTypes.func.isRequired,
  beneficiary: PropTypes.object,
  activeTerms: PropTypes.arrayOf(PropTypes.object),
  getActiveTerms: PropTypes.func.isRequired,
}

TermsModal.defaultProps = {
  isOpen: false,
  beneficiary: {},
  activeTerms: []
}

const mapStateToProps = ({ loan }) => ({
  activeTerms: loan.activeTerms,
})

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    getActiveTerms: getActiveTermsAction,
  },
  dispatch
)

export default connect(mapStateToProps, mapDispatchToProps)(TermsModal)
